// Filas de la planilla de pago masivo (banco).
//
// El backend (`GET /billing/driver-payroll/bank-export`) arma sus filas con el documento
// solo ELEGIDO (factura/boleta) + datos bancarios completos + monto > 0: no mira el ESTADO
// del documento. Por eso la planilla incluía repartidores con documento sin autorizar y su
// total no cuadraba con el de "Elegibles" de la vista (caso real de la semana 2026-08-30:
// 39.921.043 en la planilla contra 36.377.859 elegibles).
//
// Acá se dejan SOLO las filas de los elegibles —misma clasificación que la vista
// (`classifyDriver` → cola 'pagar': documento aceptado, cuenta a nombre del emisor y datos
// bancarios completos)— para que planilla y lista "Elegibles" digan lo mismo. Los que
// quedan fuera siguen visibles en el asistente ("Quedan fuera"), con su motivo.
//
// Además la columna "Correo beneficiario" va con el correo de la CUENTA del repartidor
// (`users.email`): no hace falta un email bancario aparte. Si la cuenta no tiene correo (o
// el directorio no cargó) la celda queda VACÍA: nunca se rellena con el email bancario,
// que es otra dirección y mandaría el aviso del banco a quien no corresponde.

/**
 * @param {object} input
 * @param {Array<object>} input.rows filas del bank-export (una por transferencia)
 * @param {Set<string>|string[]} input.eligibleIds ids de los elegibles del período
 * @param {(driverId: string) => (string|undefined)} [input.getEmail] correo de la cuenta
 * @returns {Array<object>} filas listas para el .xlsx (mismas claves + `beneficiaryEmail`)
 */
export function selectBankSheetRows({ rows = [], eligibleIds, getEmail } = {}) {
  const eligible =
    eligibleIds instanceof Set ? eligibleIds : new Set((eligibleIds ?? []).map(String));
  const out = [];
  for (const row of rows) {
    const id = String(row?.driverId ?? '');
    if (!eligible.has(id)) continue;
    out.push({
      ...row,
      beneficiaryEmail: String(getEmail?.(id) ?? '').trim(),
    });
  }
  return out;
}
